<div>
  <!-- Error Message -->
  <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    {{ errorMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''" aria-label="Close"></button>
  </div>

  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h5 class="mb-0">
      <i class="bi bi-clipboard-check me-2"></i>
      Safety Test Results
      <span *ngIf="!loading" class="badge bg-secondary ms-2">{{ results.length }}</span>
    </h5>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 text-muted">Loading test results...</p>
  </div>

  <!-- Content -->
  <div *ngIf="!loading && !errorMessage">
    <!-- Empty State -->
    <div *ngIf="results.length === 0" class="text-center py-5 text-muted">
      <i class="bi bi-clipboard-check fs-1 d-block mb-3"></i>
      <p>No test results found for this organization</p>
    </div>

    <!-- Test Results Table -->
    <div *ngIf="results.length > 0">
      <div class="table-responsive">
        <table class="table data-table table-hover mb-0">
          <thead>
            <tr>
              <th>Member Name</th>
              <th>Test Name</th>
              <th>Date Taken</th>
              <th>Score</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let result of results">
              <td>
                <span class="fw-medium">{{ getMemberName(result) }}</span>
              </td>
              <td>{{ result.testName || '-' }}</td>
              <td>{{ formatDate(result.completedAt) }}</td>
              <td>{{ result.score != null ? result.score + '%' : '-' }}</td>
              <td>
                <span class="badge" [ngClass]="result.passed ? 'bg-success' : 'bg-danger'">
                  {{ result.passed ? 'Passed' : 'Failed' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
